import {Component, inject} from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {UsersService} from "../../../services/users.service";
import {ICellRendererParams} from "ag-grid-community";
import {IAdminQueryResult} from "../../../interfaces/IAdminQueryResult";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {SnackbarService} from "../../../services/snackbar.service";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-org-causable-settings',
  standalone: true,
  templateUrl: './org-causable-settings.component.html',
  imports: [
    HasPermissionDirective,
    MatMenuTrigger,
    MatIconButton,
    MatIcon,
    MatTooltip,
    MatMenu,
    MatMenuItem,
    MatProgressSpinner
  ],
  styleUrls: ['./org-causable-settings.component.scss']
})
export class OrgCausableSettingsComponent implements ICellRendererAngularComp {
  public permissionTypes = PermissionTypes;
  public rowData!: IAdminQueryResult;
  public params!: any;
  public gameId: string = '';
  public uiState = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;

  private snackBarService: SnackbarService = inject(SnackbarService);

  constructor(private userService: UsersService) {
  }

  agInit(params: ICellRendererParams & {
    gameId: string
  }): void {
    this.params = params;
    this.rowData = params.data;
    this.gameId = params.gameId;
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }

  onDeactivateUserClick() {
    this.userService.onDeactivateUserClick(this.rowData, this.gameId);
  }

  onReactiveUserClick() {
    this.userService.onReactivateUserClick(this.rowData, this.gameId);
  }

  onResendInviteClick() {
    this.uiState = UIStateEnum.ShowLoading;
    this.userService.resendCausableAdminInvite({
      targetAdminId: this.rowData.Id,
      redirectUrl: `${window.location.origin}/login`,
    }).subscribe({
      next: () => {
        this.uiState = UIStateEnum.ShowData;
        this.snackBarService.openSuccessfulSnackBar("Successfully resent email");
      },
      error: err => {
        this.uiState = UIStateEnum.ShowData;
        this.snackBarService.openErrorSnackBar("Looks like there was an error resending the email. Please try again or contact a system admin");
      }
    })
  }
}
